import fancybox from '@fancyapps/fancybox/dist/jquery.fancybox.min';
import 'fancybox-polish';

export default function initializeFancybox() {
    $('[data-fancybox]').fancybox({
        buttons: [
            "zoom",
            "close"
        ],
        toolbar: true,
        idleTime: false,
        loop: true,
        lang: document.body.dataset.lang,
        afterLoad: function (instance, current) {
            current.$image.attr('alt', current.opts.$orig.find('img').attr('alt'));
            $('.fancybox-container.fancybox-is-open').attr('aria-label', current.opts.$orig.find('img').attr('alt'));
            $('.site-container').attr('aria-hidden', true);
        },
        afterClose: function (instance, current) {
            $('.site-container').attr('aria-hidden', false);
        },
        onInit: function (instance, current) {
            $('.fancybox-container').attr('aria-modal', true);
            $('.fancybox-button').on('click', function (e) {
                e.preventDefault();
            });
        },
        btnTpl: {
            zoom:
                '<a href="#" data-fancybox-zoom class="fancybox-button fancybox-button--zoom">' +
                '<span class="fancybox-button__title">{{ZOOM}}</span>' +
                '<svg aria-label="" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg>' +
                "</a>",

            close:
                '<a href="#" data-fancybox-close class="fancybox-button fancybox-button--close">' +
                '<span class="fancybox-button__title">{{CLOSE}}</span>' +
                '<svg aria-label="" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
                "</a>",

            arrowLeft:
                '<a href="#" data-fancybox-prev class="fancybox-button fancybox-button--arrow_left">' +
                '<span class="fancybox-button__title">{{PREV}}</span>' +
                '<div><svg aria-label="" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div>' +
                "</a>",

            arrowRight:
                '<a href="#" data-fancybox-next class="fancybox-button fancybox-button--arrow_right">' +
                '<span class="fancybox-button__title">{{NEXT}}</span>' +
                '<div><svg aria-label="" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div>' +
                "</a>",
        }
    });
}